import { createContext } from 'react';



export const ShippingContext = createContext(25);